import { getRelativePath } from "base/shared/Utils";

const BASE_PATH = "/listings";

export const getListingsPath = () => getRelativePath(BASE_PATH);
